import { jsxs as p, jsx as r } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import e from "styled-components";
const l = e.div.withConfig({
  displayName: "Root"
})([
  "display:flex;flex-direction:column;font-size:",
  ";font-weight:",
  ";color:currentColor;letter-spacing:normal;line-height:1.2em;"
], ({ theme: o }) => o.typography.body200.fontSize, ({ theme: o }) => o.typography.fontWeightRegular), y = e.div.withConfig({
  displayName: "PrimaryWrapper"
})([
  "font-weight:",
  ";"
], ({ theme: o }) => o.typography.fontWeightMedium), f = e.div.withConfig({
  displayName: "SecondaryWrapper"
})([
  "margin-top:2px;color:",
  ";font-size:",
  ";"
], ({ theme: o, $selected: t }) => t ? o.secondaryBackground : o.text.tertiary, ({ theme: o }) => o.typography.body100.fontSize), c = /* @__PURE__ */ s(({ children: o = void 0, primary: t = void 0, secondary: i = void 0, selected: a = !1, ...n }, d) => /* @__PURE__ */ p(l, {
  ref: d,
  ...n,
  children: [
    /* @__PURE__ */ r(y, {
      children: t ?? o
    }),
    /* @__PURE__ */ r(f, {
      $selected: a,
      children: i
    })
  ]
}));
c.displayName = "ListItemText";
export {
  c as default
};
